export default "__VITE_ASSET__DZKP6P4D__"